export const formatGradient = (value) => {
    const { colors, ratios } = value;

    const params = {};

    if (colors instanceof Array) {
        const [color0, color1, color2] = colors;

        params.color0 = color0;
        params.color1 = color1;
        params.color2 = color2;
    }

    if (ratios instanceof Array) {
        const [ratio0, ratio1, ratio2] = ratios;

        params.ratio0 = ratio0;
        params.ratio1 = ratio1;
        params.ratio2 = ratio2;
    }

    return params;
};
